import React from "react";
var TextWithLinks = function (_a) {
    var text = _a.text;
    var reg = /(https?:\/\/[^\s]+)/g;
    var renderTextWithLinks = function (text) {
        if (!text)
            return null;
        var parts = text.split(reg);
        return parts.map(function (part, index) {
            if (reg.test(part)) {
                return (React.createElement("a", { key: index, href: part, target: "_blank", rel: "noopener noreferrer", style: {
                        color: '#007bff',
                        textDecoration: 'underline'
                    } }, part));
            }
            return React.createElement("p", null, part);
        });
    };
    return React.createElement("div", null, renderTextWithLinks(text));
};
export default TextWithLinks;
//# sourceMappingURL=textWithLinks.js.mapimport React from "react";
var TextWithLinks = function (_a) {
    var text = _a.text;
    var reg = /(https?:\/\/[^\s]+)/g;
    var renderTextWithLinks = function (text) {
        if (!text)
            return null;
        var parts = text.split(reg);
        return parts.map(function (part, index) {
            if (reg.test(part)) {
                return (React.createElement("a", { key: index, href: part, target: "_blank", rel: "noopener noreferrer", style: {
                        color: '#007bff',
                        textDecoration: 'underline'
                    } }, part));
            }
            return React.createElement("p", null, part);
        });
    };
    return React.createElement("div", null, renderTextWithLinks(text));
};
export default TextWithLinks;
//# sourceMappingURL=textWithLinks.js.map